module.exports = __webpack_public_path__ + "static/media/4_Profil_haninge.913a64d9.jpg";